export class SettingConfigurations {
    useResultsConfiguration: boolean;
    useResults: boolean;
    enableSelfReport: boolean;
    enableDashboard: boolean;
    enableOrderResultsView: boolean;
    useDocumentSharing: boolean;
    useResultsV2: boolean;
    resultViewAccounts: string;

    enableOSIS: boolean;
    newWaysOfCreatingOrdersEnabled: boolean;
    disableViewQuotation: boolean;
    enableProject: boolean;
    enableSampleQuantityDisplay: string;
    enableSampleTaker: boolean;
    disableLimitSets: boolean;
    enableMyStatistics: boolean;
    enableFloorplans: boolean;
    enableSampleStatusTracking: boolean;
    disableInvoices: boolean;
    enableDropOff: boolean;
    enableAlerts: boolean;
    enableContactPage: boolean;
    enableProductManagement: boolean;
    enableLabContactPage: boolean;
    eIMASLogonURL: string;
    eIMASClientApplicationID: string;
    enableAdvancedSupportPage: boolean;
    expressOrderingUrl: string;
    enableExpressOrdering: boolean;
    configureSortPatternUri: string;
    productManagementEIMASLogonURL: string;
    manageFavouriteOrders: boolean;
    usePartialOrderEntry: boolean;
    useOfferFileExport: boolean;
    disableParameterSortings: boolean;
    enableLocalApplicationIntegration: boolean;
    enableMultipleAssessments: boolean;
    enableOSOIntegration: boolean;
    enableGuidedOrder: boolean;
    myResultsNewUrl: string;
    defaultOrderingService: string;
    FrequentlyUsedDenUnits: string[];
    FrequentlyUsedNumUnits: string[];
    MaxSelectionOfAnalyses: number;
    EnableSchedulingRecurrentOrder: boolean;
    elimsTransitionedLabsiteAccounts: { LabsiteCode: string; AccountCodes: string[] }[];
}
